var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgConfirmIcon = function SvgConfirmIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "97px",
    height: "96px",
    viewBox: "0 0 97 96",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2FC991",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B8E5E",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-2",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "10.0-Telecounselling",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "10.1.24-Telecounsel-/-Queue----disconnected-call---complete-counsel",
    transform: "translate(-672, -299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04.Organisms/07.Card/03.Popup/No-subtext-Copy",
    transform: "translate(520, 259)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(152.597, 40)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "url(#linearGradient-1)",
    cx: 48,
    cy: 48,
    r: 48
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E2F2FF",
    opacity: 0.200000003,
    cx: 48,
    cy: 48,
    r: 39.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(28, 28)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "checkmark-circle",
    mask: "url(#mask-3)",
    fill: "#E0FFF4",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.6667, 6.6667)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5416667,0 C6.07486979,0 0,6.07486979 0,13.5416667 C0,21.0084635 6.07486979,27.0833333 13.5416667,27.0833333 C21.0084635,27.0833333 27.0833333,21.0084635 27.0833333,13.5416667 C27.0833333,6.07486979 21.0084635,0 13.5416667,0 Z M20.5891927,9.00325521 L11.8391927,19.4199219 C11.6449854,19.6512394 11.3599382,19.7868743 11.0579427,19.7916667 L11.0403646,19.7916667 C10.7450928,19.7916667 10.463739,19.6661454 10.266276,19.4466146 L6.51627604,15.2799479 C6.25702459,15.0049761 6.16703692,14.6111585 6.28113233,14.2508765 C6.39522774,13.8905946 6.69550729,13.6203683 7.0657826,13.5447573 C7.43605792,13.4691463 7.81824135,13.6000123 8.06445313,13.8867188 L11.0130208,17.1627604 L18.9941406,7.66341146 C19.3666525,7.2327314 20.0159666,7.18099099 20.4519819,7.54724379 C20.8879971,7.91349659 20.94911,8.56199574 20.5891927,9.00325521 Z"
  }))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgConfirmIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/confirm-icon.e9958914.svg";
export { ForwardRef as ReactComponent };